export const SET_GAMES = 'SET_GAMES';
export const SET_GAME = 'SET_GAME';
export const ADD_GAME = 'ADD_GAME';
export const UPDATE_GAME = 'UPDATE_GAME';
export const REMOVE_GAME = 'REMOVE_GAME';
export const CLEAR_GAME = 'CLEAR_GAME';
export const CLEAR_GAMES = 'CLEAR_GAMES';
